module.exports = __webpack_public_path__ + "static/media/agriculture.5f7e7c52.jpg";